import React, { useState } from 'react';
import { useLostCargoReturnDetailPage } from '../context/LostCargoReturnDetailPageContext';
import { useTranslation } from 'react-i18next';
import LostCargoReturnDetailCustomGrid from './LostCargoReturnDetailCustomGrid';
import { Card, Chip, Divider, Button, Drawer, Tooltip } from '@mui/material';
import './LostCargoReturnDetail.scss'
import LostCargoReturnDetailInfoCard from './LostCargoReturnDetailInfoCard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReturnStatusHistoryDrawer from '../../Return/ReturnDetail/components/ReturnStatusHistoryDrawer/ReturnStatusHistoryDrawer';
import { LCRD, lcrDetailCls } from '../lostCargoReturnDetailPage.classes';

function LostCargoReturnDetailSearchProductList() {
  const { returnDetailData } = useLostCargoReturnDetailPage();
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const completedStatus = "Completed";
  const handleOpenDrawer = () => setDrawerOpen(true);
  const handleCloseDrawer = () => setDrawerOpen(false);

  return (
    <div>
      {returnDetailData ? (
        <>
          <Card className={lcrDetailCls('infoContainer', LCRD.summaryCard)}>
            <div className={LCRD.summaryCardHeader} style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
              <h3 className={LCRD.summaryCardTitle} style={{ marginLeft: "0.5rem" }}>
                <strong> {t("lostCargoReturnPageBuilder.lostCargoReturnDetail")}</strong>
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Chip
                  className={LCRD.summaryStatusChip}
                  label={returnDetailData?.statusDescription}
                  color={returnDetailData?.statusCode == completedStatus ? 'success' : 'warning'}
                />
                <Tooltip title={t('return.returnStatusHistory')}>
                  <Button className={LCRD.inputButtonReturnStatusHistory} onClick={handleOpenDrawer} style={{ minWidth: 'auto', padding: 0 }}>
                    <AccessTimeIcon style={{ fontSize: '2rem', color: '#03a9f4' }} />
                  </Button>
                </Tooltip>
              </div>
            </div>
            <Divider />
            <LostCargoReturnDetailInfoCard />
          </Card>
          <Drawer
            anchor="top"
            open={drawerOpen}
            onClose={handleCloseDrawer}
            slotProps={{ paper: { className: LCRD.statusHistoryDrawerPaper } }}
          >
            <ReturnStatusHistoryDrawer returnId={returnDetailData.returnId} onClose={handleCloseDrawer} />
          </Drawer>
          <LostCargoReturnDetailCustomGrid />
        </>) : (
        <div className={LCRD.emptyStateMessage}>{t('general.noDataFound')}</div>
      )}
    </div>
  )
}

export default LostCargoReturnDetailSearchProductList